import React from 'react';
type LogoProps = {
  className?: string;
};
export function Logo({
  className = ''
}: LogoProps) {
  return <span translate="no" className={`whitespace-nowrap font-logo font-normal uppercase leading-none tracking-[0.34em] ${className}`} style={{
    marginRight: '-0.34em'
  }} data-id="element-655" data-mp="8u4t8qvvw1pz">
      Superluxury
    </span>;
}